import CanvasHandler from "./CanvasHandler";
import { FabricEvent } from "../types/FabricCustomType";
import { ObjectSuperTypesEnum, SelectionTypeEnum } from "../enums";
import { findObjectInCanvas } from "../utils/ObjectUtil";

export abstract class BaseObjectHandler<T extends { 
    activateObjectHover(event: any, object: any): any; 
    deactivateObjectHover(): any;
    handleObjectLockUpdate?(object: any, hubItem: any, selectorKey: any): any;
}> {
  protected objectTypes: Record<string, T>;
  protected object: T;
  public selectedType: string;
  protected canvasHandler: CanvasHandler;

  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
  }

  public setType(type: string) {
    this.selectedType = type;
    this.object = this.objectTypes[type];
  }

  public updateObjectHoverState(event: FabricEvent<MouseEvent | TouchEvent>) {
    if (event.target) {
      switch (event.target.superType) {
        case ObjectSuperTypesEnum.Row:
        case ObjectSuperTypesEnum.RectTable:
        case ObjectSuperTypesEnum.RoundTable:
          if( event.target?.selectionType && event.target?.selectionType === SelectionTypeEnum.byTable){
             const table = event.target._objects[0];
            if (table) {
              this.setType(ObjectSuperTypesEnum.Table);
              this.object.activateObjectHover(event, table);
            } else {
              this.deactivateObjectHover();
            }
          }
          else{
            const seat = event.subTargets?.find((t: any) => t?.superType === ObjectSuperTypesEnum.Seat);
            if (seat) {
              this.setType(ObjectSuperTypesEnum.Seat);
              this.object.activateObjectHover(event, seat);
            } else {
              this.deactivateObjectHover();
            }
          }
          break;
        default:
          this.deactivateObjectHover();
          break;
      }
    } else {
      this.deactivateObjectHover();
    }
  }

  public handleObjectLockUpdate(valueHub: any) {
    valueHub.objects.forEach((item: any) => {
      const result = findObjectInCanvas(this.canvasHandler, item.parentKey, item.objectKey) as any;
      if (!result?.object) return;
      const {object, group} = result;
      this.setType(object.superType)
      if (this.object?.handleObjectLockUpdate) {
        this.object.handleObjectLockUpdate(object, item, valueHub.selectorKey);
        group.addWithUpdate();
      }
    })
  }

  public deactivateObjectHover() {
    if (this.object) {
      this.object.deactivateObjectHover();
    }
  }
}

export default BaseObjectHandler;
